import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  Button,
  CircularProgress,
  Box,
  TextField,
  Pagination,
  FormControl,
  Autocomplete,
  Tooltip,
  IconButton,
  Switch,
  Stack,
  Typography,
} from '@mui/material';

import moment from 'moment';
import { useState } from 'react';
import HttpService from '../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  dateFormat,
  timeFormat,
} from '../../utils/constant';
import { useNavigate } from 'react-router';
import Iconify from '../../components/iconify';

function AssignRequest() {
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [selectedDuration, setSelectedDuration] = useState<number | null>(null);

  const fetchNotificationList = React.useCallback(async () => {
    const query: any = {
      page: currentPage,
      limit: itemsPerPage,
      notification_type: 7,
    };

    try {
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.assignRequestList +
          `?${new URLSearchParams(query).toString()}`
      );
      setTableData(response.data.data.list || []);
      setTotalPages(response.data.data.totalPages);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, selectedDuration]);

  React.useEffect(() => {
    fetchNotificationList();
  }, [fetchNotificationList]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  const handleNavigateToUser = (id: any) => {
    navigate(`/assing-game/${id}`);
  };

  function Row(props: { row: any }) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.user?.email}
          </TableCell>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.user?.name}
          </TableCell>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.createdAt ? (
              <Stack direction={'column'}>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${dateFormat}`)}
                </Typography>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${timeFormat}`)}
                </Typography>
              </Stack>
            ) : (
              '-'
            )}
          </TableCell>

          <TableCell
            align="left"
            sx={{ margin: '0', padding: '0', whiteSpace: 'nowrap' }}
          >
            <Tooltip title="User Details" placement="top" arrow>
              <IconButton
                onClick={() => {
                  handleNavigateToUser(row.id); // Set the current user for quick edit
                }}
              >
                <Iconify icon="flowbite:eye-solid" />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  return (
    <>
      {' '}
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Email</TableCell>
              <TableCell align="left">User Name</TableCell>
              <TableCell align="left">Created At</TableCell>
              <TableCell align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tableData || []).map((data: any) => (
              <Row key={data.id} row={data} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default AssignRequest;
